import Chip, { type ChipProps } from "@mui/material/Chip";
import { RequestStatus } from "../domain/request.types";

const STATUS_COLORS: Record<RequestStatus, ChipProps["color"]> = {
  [RequestStatus.Submitted]: "info",
  [RequestStatus.Assigned]: "primary",
  [RequestStatus.Rejected]: "error",
  [RequestStatus.InProgress]: "warning",
  [RequestStatus.Completed]: "success",
  [RequestStatus.ReworkRequired]: "error",
};

const STATUS_LABELS: Record<RequestStatus, string> = {
  [RequestStatus.Submitted]: "Submitted",
  [RequestStatus.Assigned]: "Assigned",
  [RequestStatus.Rejected]: "Rejected",
  [RequestStatus.InProgress]: "In Progress",
  [RequestStatus.Completed]: "Completed",
  [RequestStatus.ReworkRequired]: "Rework Required",
};

export interface StatusChipProps {
  status: RequestStatus;
  size?: "small" | "medium";
}

export function StatusChip({ status, size = "small" }: StatusChipProps) {
  return (
    <Chip
      label={STATUS_LABELS[status]}
      color={STATUS_COLORS[status]}
      size={size}
      variant="filled"
    />
  );
}
